import { DeclarationStatusDto } from "../types/Api";
/**
 * Registration agency (ISBN/ISMN) a publisher prefix belongs to, read from its nested
 * range → agency prefix → international prefix. Returns undefined when the chain is incomplete.
 */
export var getPrefixAgency = function (prefix) { var _a, _b, _c; return (_c = (_b = (_a = prefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix) === null || _c === void 0 ? void 0 : _c.agency; };
/**
 * Human-readable label for a publisher prefix, mirroring the prefixes table:
 * "<agency> <international>-<agencyValue> <value>" (e.g. "ISBN 978-80 7702").
 * Missing parts are dropped so the label never shows stray separators.
 */
export var getPublisherPrefixLabel = function (prefix) {
    var _a, _b, _c, _d, _e, _f, _g;
    var agencyPrefix = (_a = prefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix;
    var agency = (_c = (_b = agencyPrefix === null || agencyPrefix === void 0 ? void 0 : agencyPrefix.internationalPrefix) === null || _b === void 0 ? void 0 : _b.agency) !== null && _c !== void 0 ? _c : "";
    var internationalValue = (_e = (_d = agencyPrefix === null || agencyPrefix === void 0 ? void 0 : agencyPrefix.internationalPrefix) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : "";
    var agencyValue = (_f = agencyPrefix === null || agencyPrefix === void 0 ? void 0 : agencyPrefix.value) !== null && _f !== void 0 ? _f : "";
    var head = "".concat(agency, " ").concat(internationalValue, "-").concat(agencyValue)
        .replace(/^\s+|-\s*$/g, "")
        .trim();
    var value = (_g = prefix.value) !== null && _g !== void 0 ? _g : "";
    return [head, value].filter(Boolean).join(" ").trim();
};
/**
 * Selects the active publisher prefixes still awaiting a last-used-number declaration.
 *
 * The create dialog and the module entry gate both need exactly this: prefixes with
 * declarationStatus === PENDING, optionally narrowed to a single registration agency
 * (ISBN/ISMN) — the feasibility answer carries the agency but not the offending prefix id,
 * so the client resolves the concrete prefix(es) from the publisher-scoped list itself.
 */
export var getPendingDeclarationPrefixes = function (prefixes, agency) {
    return (prefixes !== null && prefixes !== void 0 ? prefixes : []).filter(function (prefix) {
        return prefix.declarationStatus === DeclarationStatusDto.PENDING &&
            (!agency || getPrefixAgency(prefix) === agency);
    });
};
